"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowStepPendingFlag = exports.FlowGoToNextButton = exports.FlowStartButton = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("./GuidedFlowButtons.css"));
var FlowStartButton = function (_a) {
    var onClick = _a.onClick;
    return (react_1.default.createElement("button", { type: "button", onClick: onClick, className: styles.buttonReset },
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.startButton },
            react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "m" }, "Start"))));
};
exports.FlowStartButton = FlowStartButton;
var FlowGoToNextButton = function (_a) {
    var onClick = _a.onClick;
    return (react_1.default.createElement("button", { type: "button", onClick: onClick, className: styles.buttonReset },
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", justify: "center" },
            react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.nextButton },
                react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "m" }, "Next")),
            react_1.default.createElement(GuidedFlowArrow, null))));
};
exports.FlowGoToNextButton = FlowGoToNextButton;
var FlowStepPendingFlag = function (_a) {
    var label = _a.label, isMobile = _a.isMobile;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: isMobile ? "vertical" : "horizontal", align: "center", justify: "center" },
        react_1.default.createElement(kaleidoscope_1.Stack, { className: "".concat(styles.pendingFlag, " ").concat(styles.pendingFlagRadiusControl({ isMobile: isMobile })) },
            react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "m" }, label)),
        isMobile ? react_1.default.createElement(GuidedFlowArrowDown, null) : react_1.default.createElement(GuidedFlowArrow, null)));
};
exports.FlowStepPendingFlag = FlowStepPendingFlag;
var GuidedFlowArrow = function () { return (react_1.default.createElement("svg", { style: { zIndex: 2 }, xmlns: "http://www.w3.org/2000/svg", width: "23", height: "40", fill: "none", viewBox: "0 0 23 40" },
    react_1.default.createElement("path", { fill: "#FFDF8B", d: "M6.343 2.343A8 8 0 0 0 .686 0H0v40h.686a8 8 0 0 0 5.657-2.343l14.829-14.829a4 4 0 0 0 0-5.656L6.343 2.343Z" }))); };
var GuidedFlowArrowDown = function () { return (react_1.default.createElement("svg", { style: { zIndex: 2 }, xmlns: "http://www.w3.org/2000/svg", width: "9", height: "8", fill: "none", viewBox: "0 0 9 8" },
    react_1.default.createElement("path", { fill: "#FFDF8B", d: "M8.012 2.147A3.375 3.375 0 0 1 9 .289V0H0v.289c0 .83.386 1.613 1.044 2.114l2.88 4.57a1.688 1.688 0 0 0 1.261 0l2.827-4.826Z" }))); };
